
<template>

    <div>
        <!-- Orders List header -->
        <a-row type="flex" :gutter="24">
            <a-col :span="12" class="mb-24">
                <label style="margin-right: 15px"><strong>Tanggal</strong></label>
                <a-dropdown :trigger="['click']">
                    <a-button class="ant-dropdown-link" @click="e => e.preventDefault()">
                        {{ filterDateText }}
                        <a-icon class="ml-5" type="down"/>
                    </a-button>
                    <a-menu slot="overlay">
                        <a-menu-item key="0" @click="setFilterTanggal('all')">Semua</a-menu-item>
                        <a-menu-item key="1" @click="setFilterTanggal('this_day')">Hari Ini</a-menu-item>
                        <a-menu-item key="2" @click="setFilterTanggal('this_week')">Minggu Ini</a-menu-item>
                        <a-menu-item key="3" @click="setFilterTanggal('this_month')">Bulan Ini</a-menu-item>
                        <a-menu-item key="4" disabled style="cursor: pointer">
                            <div style="color: #595959; margin-bottom: 5px">Tanggal</div>
                            <a-date-picker style="width: 140px" placeholder="Tanggal Awal" @change="setTanggalAwal"></a-date-picker>
                            <a-date-picker style="width: 140px; margin-left: 5px" placeholder="Tanggal Akhir" @change="setTanggalAkhir"></a-date-picker>
                        </a-menu-item>

                    </a-menu>
                </a-dropdown>

            </a-col>
        </a-row>
        <!-- / Orders List header -->

        <a-card :bordered="false" class="header-solid mb-24" :bodyStyle="{padding: 0, paddingTop: '16px'}">

            <a-button @click="getData()" style="position: absolute; left: 10px; top: 10px; z-index: 10" class="no-shadow">
                <a-icon type="reload"></a-icon>
            </a-button>

            <div class="mx-25">
                <a-row type="flex" :gutter="24">
                    <a-col :span="24" class="text-right">
                        <a-input-search placeholder="input search text" style="max-width: 200px;" v-model="query"/>
                    </a-col>
                </a-row>
            </div>

            <a-table class="mt-20"
                     :columns="columns"
                     :data-source="filteredData"
                     :pagination="{pageSize: 10}"
                     rowKey="no"
            >

                <template slot="id" slot-scope="id">#{{ id }}</template>

                <template slot="total" slot-scope="row">
                    <div style="text-align: right">
                        {{ formatPrice(row.total) }}
                    </div>
                </template>

                <template slot="jumlah" slot-scope="row">
                    <div style="text-align: right">
                        {{ row.jumlah_item }}
                    </div>
                </template>

                <template slot="status" slot-scope="row">
                    <div class="status status-blm-bayar" v-if="row.status_lunas === 'belum bayar'" style="text-align: center">
                        Belum Bayar
                    </div>
                    <div class="status status-lunas" v-else-if="row.status_lunas === 'sudah bayar'" style="text-align: center">
                        Lunas
                    </div>
                </template>

                <template slot="tanggal" slot-scope="row">
                    {{ formatTanggal(row) }}
                </template>

            </a-table>

        </a-card>
    </div>

</template>

<script>

// Table columns
import {dateFormatIndo, dateFormatIndoShortWithTime, formatPrice, isDateWithin} from "../../../utils/Extenstion";
import BillingApi from "../../../repository/api/BillingApi";
import SettingRepository from "../../../repository/SettingRepository";

const columns = [
    {
        title: 'No',
        dataIndex: 'no',
        sortDirections: ['descend', 'ascend'],
        scopedSlots: {customRender: 'id'},
    },
    {
        title: 'Nama Tindakan',
        dataIndex: 'nama',
        sortDirections: ['descend', 'ascend'],
    },
    {
        title: 'Nama Pasien',
        dataIndex: 'nama_pasien',
        sortDirections: ['descend', 'ascend'],
    },
    {
        title: 'No RM',
        dataIndex: 'no_rm',
        sortDirections: ['descend', 'ascend'],
    },
    {
        title: 'Kode Tindakan',
        dataIndex: 'kode',
        sortDirections: ['descend', 'ascend'],
    },
    {
        title: 'Jumlah',
        scopedSlots: { customRender: 'jumlah' },
    },
    {
        title: 'Total',
        scopedSlots: { customRender: 'total' },
    },
    {
        title: 'Tanggal',
        scopedSlots: { customRender: 'tanggal' },
    },
    {
        title: 'Kode Booking',
        dataIndex: 'kode_booking',
        sortDirections: ['descend', 'ascend'],
    },
    {
        title: 'Status',
        scopedSlots: { customRender: 'status' },
    },
]

export default {
    name: "ListBillingKoas",

    data() {
        return {
            columns,
            data: [],

            filterDateText: SettingRepository.get("ListBillingKoas", "filterDateText") ?? 'Semua',
            filterDateValue: SettingRepository.get("ListBillingKoas", "filterDateValue") ?? 'all',
            filterDateStart: SettingRepository.get("ListBillingKoas", "filterDateStart") ?? '',
            filterDateEnd: SettingRepository.get("ListBillingKoas", "filterDateEnd") ?? '',

            query: '',
        }
    },

    async mounted() {
        this.getData()
    },

    methods: {
        getData() {
            BillingApi.get(this.$store.getters['auth/user'].user.username)
                .then((response) => {
                    this.data = response.sort((a, b) => b.created_at.localeCompare(a.created_at))
                })
                .catch((e) => {
                    this.$swal({
                        icon: e.severity || "error",
                        title: (e.severity || "error").toUpperCase(),
                        text: e.message,
                    });
                })
        },

        // Filter ===================================
        // ==========================================
        setFilterTanggal(id) {
            this.filterDateValue = id
            const dateTexts = {
                'all': 'Semua',
                'this_day': 'Hari Ini',
                'this_week': 'Minggu Ini',
                'this_month': 'Bulan Ini',
            }

            this.filterDateText = dateTexts[id]
        },

        setTanggalAwal(date, dateString) {
            this.filterDateStart = dateString
            this.setTanggal()
        },

        setTanggalAkhir(date, dateString) {
            this.filterDateEnd = dateString
            this.setTanggal()
        },

        setTanggal() {
            if (this.filterDateStart) {
                this.filterDateText = dateFormatIndo(this.filterDateStart)
                this.filterDateValue = this.filterDateStart

                if (this.filterDateEnd) {
                    this.filterDateText += ' - ' + dateFormatIndo(this.filterDateEnd)
                    this.filterDateValue += ' ' + this.filterDateEnd
                }
            }
            else {
                this.filterDateText = "Semua"
                this.filterDateValue = "all"
            }
        },

        // Helper ====================================
        // ===========================================
        formatTanggal(row) {
            return dateFormatIndoShortWithTime(row.created_at)
        },

        formatPrice(num) {
            return formatPrice(num)
        },
    },

    computed: {
        filteredData() {
            return this.data.filter(x => {
                return (this.filterDateValue === 'all' || isDateWithin(x.created_at, this.filterDateValue)) &&
                    (x.nama.toLowerCase().includes(this.query.toLowerCase()) ||
                    x.nama_pasien && x.nama_pasien.toLowerCase().includes(this.query.toLowerCase()) ||
                    x.no_rm && x.no_rm.toLowerCase().includes(this.query.toLowerCase()) ||
                    x.kode && x.kode.toLowerCase().includes(this.query.toLowerCase()) ||
                    x.jumlah_item && x.jumlah_item.toString().toLowerCase().includes(this.query.toLowerCase()) ||
                    x.total && x.total.toString().toLowerCase().includes(this.query.toLowerCase()) ||
                    x.nama_pasien && x.kode_booking.toLowerCase().includes(this.query.toLowerCase()))
            }).map((item, index) => ({
                ...item,
                no: index + 1,
            }))
        }
    },

    watch: {
        filterDateText: function (n, o) {
            SettingRepository.save("ListBillingKoas", "filterDateText", n)
        },

        filterDateValue: function (n, o) {
            SettingRepository.save("ListBillingKoas", "filterDateValue", n)
        },

        filterDateStart: function (n, o) {
            SettingRepository.save("ListBillingKoas", "filterDateStart", n)
        },

        filterDateEnd: function (n, o) {
            SettingRepository.save("ListBillingKoas", "filterDateEnd", n)
        },
    }
}

</script>

<style lang="scss" scoped>

.status {
    background: red;
    border-radius: 100px;
    color: white;
    white-space: nowrap;
    font-size: 11px;
    padding: 3px 5px;
}

.status-blm-bayar {
    background: #de5656;
}

.status-lunas {
    background: #357936;
}

</style>
